<template>
    <div class="page-class"
        :class="[{'page-mass': theme == 'mass'}, {'page-prestige': theme == 'prestige'}]">
        <div v-if="isAccountLoaded">
            <AIAHeader
                @clickBack="clickBack" />

            <HistoryDateSelect
                :lbl="lbl"
                :localeCode="localeCode"
                :historyController="historyController" />

            <HistoryTab
                :lbl="lbl"
                :activeTabProp="activeTab"
                :historyController="historyController" />

            <HistoryList
                :lbl="lbl"
                :historyController="historyController" />

            <AIAFootMenu
                :pageName="pageName"
                :modalController="modalController" />
        </div>
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//import Vue from "vue";
//core
//helper
import Account from '@/helper/AccountHelper.js';
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//layout
import AIAHeader from "@/components/Layout/header/AIAHeader.vue";
import AIAFootMenu from "@/components/Layout/footer/AIAFootMenu.vue";
//component
import HistoryDateSelect from "../component/HistoryDateSelect.vue";
import HistoryTab from "../component/HistoryTab.vue";
import HistoryList from "../component/HistoryList.vue";
//controller
import { AIAHistoryController } from '../controller/AIAHistoryController.js';
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";

export default {
    name: "History",
    components: {
        //layout
        AIAHeader,
        AIAFootMenu,
        //component
        HistoryDateSelect,
        HistoryTab,
        HistoryList,
        //modal
        ModalMaster
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            //page
            pageName: 'history',
            activeTab: 'used', //not_use, used
            //controller
            historyController: new AIAHistoryController(),
            //modal
            modalController: null
        };
    },
    beforeCreate: function () {
        if (Account.getCacheCustom("isfromhistorylanding") != undefined) {
            var landingCache = Account.getCacheCustom("isfromhistorylanding");

            if (landingCache != null) {
                Account.removeCacheCustom("isfromhistorylanding");

                if (landingCache.page == 'interface') history.go(-2);
            }
        }
    },
    created: function() {
        this.initialModal();
        this.initialControllerCallBack();
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);
    },
    mounted: function () {
        this.modalController.loadingModal.show();
    },
    methods: {
        //initial
        accountInitiated: function () {
            this.historyController.initialList(this.modalController);
        },
        initialControllerCallBack: function () {
            this.historyController.cbGetListSuccess
                .onCallback(data => {
                    console.log('get list success', data);
                });
            this.historyController.cbApiError
                .onCallback(err => {
                    this.errorApi(err, this.errorHandler);
                });
            this.historyController.cbHistoryRedirect
                .onCallback(data => {
                    window.location.replace(data.link);
                });
        },
        //#region event
        clickBack: function () {
            this.$router.back();
        },
        //#endregion
        //modal
        initialModal: function () {
            //basic modal
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.confirmModal = modalFactory.getConfirmModal();
            this.loadingModal = modalFactory.getLoadingModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
            this.successModal = modalFactory.getSuccessModal();
            this.errorModal = modalFactory.getErrorModal();
            //redeem modal
            this.confirmRedeemModal = modalFactory.getConfirmRedeemModal();
            this.redeemSuccessModal = modalFactory.getRedeemSuccessModal();
            this.serialModal = modalFactory.getSerialModal();
        }
    }
};
</script>
